import { render, staticRenderFns } from "./AccountListPage.vue?vue&type=template&id=01156c8c"
import script from "./AccountListPage.vue?vue&type=script&lang=js"
export * from "./AccountListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports